import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0789124d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "classify-box"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_5 = {
  class: "micro-list"
};
const _hoisted_6 = {
  key: 1,
  class: "no-data"
};
import Head from 'components/Head';
import Footer from 'components/Footer';
import MicroSpecialtyCard from './components/microCard';
import { Empty } from 'zhs-components';
export default {
  setup(__props) {
    const $http = inject('$http');
    const userId = ref('');

    const getUserInfo = data => {
      userId.value = data ? data.id : '';
      getMicroSpecialtyList();
    };

    const classifyList = ref([]);
    const currentClassifyId = ref('');
    const hiddenMoreClass = ref(true);

    const getClassifyList = async () => {
      const res = await $http.getClassifyList();
      classifyList.value = [{
        id: '',
        type_name: '全部'
      }, ...res];
    };

    getClassifyList(); // 切换分页

    const pageInfo = reactive({
      pageSize: 4,
      pageNum: 1,
      total: 0
    });

    const handleCurrentChange = val => {
      console.log(val);
      pageInfo.pageNum = val;
      getMicroSpecialtyList();
    }; // 微专业列表


    const microSpecialtyList = ref([]);

    const getMicroSpecialtyList = async () => {
      const {
        content,
        totalElements
      } = await $http.getMicroList({
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        specialty_type_id: currentClassifyId.value || undefined,
        userId: userId.value || undefined
      });
      microSpecialtyList.value = content;
      pageInfo.total = +totalElements;
    }; // 点击分类筛选课程


    const searchCourseList = id => {
      currentClassifyId.value = id;
      getMicroSpecialtyList();
    };

    getMicroSpecialtyList();
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(Head), {
        onGetUserInfo: getUserInfo
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["show-list", hiddenMoreClass.value && 'hidden'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classifyList.value, item => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["list-item text-overflow", currentClassifyId.value === item.id && 'active']),
          key: item.id,
          onClick: $event => searchCourseList(item.id)
        }, _toDisplayString(item.type_name), 11, _hoisted_3);
      }), 128))], 2), classifyList.value.length > 5 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["show-more-btn", !hiddenMoreClass.value && 'hidden']),
        onClick: _cache[0] || (_cache[0] = $event => hiddenMoreClass.value = !hiddenMoreClass.value)
      }, [_createTextVNode(_toDisplayString(hiddenMoreClass.value ? '展开' : '收起') + " ", 1), _hoisted_4], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [microSpecialtyList.value && microSpecialtyList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(microSpecialtyList.value, (item, index) => {
        return _openBlock(), _createBlock(_unref(MicroSpecialtyCard), {
          key: index,
          specialtyIndex: index,
          specialtyData: item
        }, null, 8, ["specialtyIndex", "specialtyData"]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(Empty), {
        text: "暂无数据"
      })]))]), _unref(pageInfo).total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        onCurrentChange: handleCurrentChange,
        layout: "prev, pager, next",
        total: _unref(pageInfo).total,
        "page-size": 4,
        "prev-text": "上一页",
        "next-text": "下一页"
      }, null, 8, ["total"])) : _createCommentVNode("", true)]), _createVNode(_unref(Footer))], 64);
    };
  }

};